export enum DrawerEvents {
    ClickedOutside,
    ClickedEsc,
    PrimaryAction,
    SecondaryAction,
    Closing,
    Closed,
    ClosedFromPrimaryAction,
    ClosedFromClickedOutside,
    ClosedFromClickedEsc,
}

export function IsClosed(drawerEvent: DrawerEvents): boolean {
    return [DrawerEvents.Closed, DrawerEvents.ClosedFromPrimaryAction, DrawerEvents.ClosedFromClickedOutside, DrawerEvents.ClosedFromClickedEsc].includes(drawerEvent);
}

export enum PrimaryActionEvent {
    Clicked,
    Success,
    Fail
}

export enum DrawerState {
    Closed,
    Default,
    Fullscreen
}

export enum DrawerWidth {
    Small = 400,
    Medium = 600,
    Large = 800
}

export enum DrawerFormMode {
    Add,
    Edit
}

export enum DrawerCloseHistoryBehavior {
    RemoveDrawerHistoryEntry = "RemoveDrawerHistoryEntry",
    BrowserBackAlreadyRemovedEntry = "BrowserBackAlreadyRemovedEntry",
    LeaveHistoryUnchanged = "LeaveHistoryUnchanged"
}
